const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:80'

/** A staff photo link from the API (`photo_url`), made absolute (USA-1456). */
export function staffPhotoSrc(photoUrl: string | null | undefined): string | undefined {
  return photoUrl ? `${API_BASE_URL}${photoUrl}` : undefined
}

export function staffInitials(name: string | null | undefined): string {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean)
  return (
    parts
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase() ?? '')
      .join('') || '?'
  )
}
